import { useDialogStateManager } from 'my-core/hooks';

import InCourseExperienceHeader from 'my-components/OnlineCourse/InCourseExperience/InCourseExperienceHeader';
import SubscriptionCheckout from 'my-components/SubscriptionCheckout';

import StudentCoursePageClassRepApplicationBanner from './StudentCoursePageClassRepApplicationBanner';
import {
  GradeBoostersExplanation,
  GradeBoosterSubscriptionOffer,
  StudentCoursePageContentsWrapper,
  StudentCoursePageFAQsCard,
  StudentCoursePageTwoColumnLayout,
} from './StudentCoursePageCommon';
import StudentCoursePageEmpty from './StudentCoursePageEmpty';
import StudentCoursePageGradeBoostersList from './StudentCoursePageGradeBoostersList';

import Grid from '@mui/material/Grid';

export default function StudentCoursePageGradeBoostersPage({
  assessments,
  classRepCourse,
  course,
  courseSubscription,
  currentUser,
  drawerOpen,
  fetching,
  onlineCourses,
  onToggleDrawer,
  studySessionBundles,
  studySessions,
  subscription,
  userCourse,
}) {
  const [subscriptionCheckoutDialogOpen, subscriptionCheckoutDialogOpened, subscriptionCheckoutDialogActions] =
    useDialogStateManager();

  return (
    <>
      <InCourseExperienceHeader
        drawerOpen={drawerOpen}
        onToggleDrawer={onToggleDrawer}
        title={`${course?.code || ''} Grade Boosters`}
        titleVariant="h6"
      />
      <StudentCoursePageContentsWrapper>
        <Grid container spacing={{ xs: 2, md: 3 }} sx={{ '& > :empty': { display: 'none' } }}>
          {!fetching && !course.has_class_rep && !classRepCourse && subscription?.status !== 'active' && (
            <Grid size={12}>
              <StudentCoursePageClassRepApplicationBanner course={course} />
            </Grid>
          )}

          <Grid size={12}>
            {fetching || studySessions.length ?
              <StudentCoursePageTwoColumnLayout>
                <div>
                  <StudentCoursePageGradeBoostersList
                    assessments={assessments}
                    course={course}
                    courseSubscription={courseSubscription}
                    currentUser={currentUser}
                    onlineCourses={onlineCourses}
                    studySessionBundles={studySessionBundles}
                    studySessions={studySessions}
                    subscription={subscription}
                    userCourse={userCourse}
                  />
                </div>
                <div>
                  <GradeBoostersExplanation />
                  {!subscription && (
                    <GradeBoosterSubscriptionOffer
                      onSubscribe={subscriptionCheckoutDialogActions.open}
                      studySessions={studySessions}
                    />
                  )}
                  <StudentCoursePageFAQsCard />
                </div>
              </StudentCoursePageTwoColumnLayout>
            : <StudentCoursePageEmpty course={course} userCourse={userCourse} />}
          </Grid>
        </Grid>
      </StudentCoursePageContentsWrapper>
      {subscriptionCheckoutDialogOpened && (
        <SubscriptionCheckout onClose={subscriptionCheckoutDialogActions.close} open={subscriptionCheckoutDialogOpen} />
      )}
    </>
  );
}
